import React, {useState} from 'react'
import style from './UndoRedo.module.css';
// import { faRedo,faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {ToggleButtonGroup, ToggleButton, Button} from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton';
import "./UndoRedo.css";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles({
  tooltip: {
    maxWidth: "260px",
    // maxHeight: "96px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
      fontSize: 12,
    // marginTop: "0px",
  },
  arrow: {
    "&:before": {
        border: "1px solid #70707075",
    },
    color: "white",
      fontSize: 15,
    },
  });

function UndoRedo(props) {
  const classes = useStyles();
  const { t } = useTranslation(["styles", "translation"]);
  return (

      <div  className="undoRedoMain">
        <Tooltip 
        title={t(`translation:UNDO_TOOLTIP_CONTENT`)}
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        placement={"bottom-start"}
        arrow>
          <IconButton className={style.undoRedoBtn} 
            style={props.undoRedoListLength.undoListLength <=1  ? {opacity:"0.6"} : {} } value="undo" onClick={(event)=>props.handleUndoRedo(event)} >
              <img src={require('../../../../Icons/NavbarIcons/Undo.svg').default} value="undo" 
              alt='Undo Icon'
                  // onClick={(event)=>props.handleUndoRedo(event)}
                />
                {/* {props.undoRedoListLength.undoListLength} */}
        </IconButton>
      </Tooltip>
      <Tooltip
        title={t(`translation:REDO_TOOLTIP_CONTENT`)}
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        placement={"bottom-start"}
            arrow>
            <IconButton className={'undoRedoBtn'} style={props.undoRedoListLength.redoListLength===0 ? {opacity:"0.6"} : {} } value="redo" onClick={(event)=>props.handleUndoRedo(event)} >
                <img src={require('../../../../Icons/NavbarIcons/Redo.svg').default} value="redo"
                alt="Redo Icon"
                  // onClick={(event)=>props.handleUndoRedo(event)}
                />
                {/* { props.undoRedoListLength.redoListLength } */}
        </IconButton>
      </Tooltip>
    </div>
    )
}

export default UndoRedo;
